import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { Component } from 'react';
import Dropzone from 'react-dropzone';
import style from './LogUploader.css';
export var LogUploader =
/*#__PURE__*/
function (_Component) {
  _inherits(LogUploader, _Component);

  function LogUploader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LogUploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LogUploader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      message: 'Load log file...'
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (files) {
      var file = files[0];
      var reader = new FileReader();

      reader.onload = function (e) {
        var content = e.target.result.trim();

        if (!_this.isLog(content)) {
          _this.setState({
            message: 'Invalid log file'
          });

          return;
        }

        _this.props.onLogFile(content);
      };

      reader.readAsText(file);
    });

    return _this;
  }

  _createClass(LogUploader, [{
    key: "isLog",
    value: function isLog(content) {
      return content[0] === '{' && content[content.length - 1] === '}';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dropStyle = {
        display: 'inline-block',
        margin: '5px'
      };
      return React.createElement(Dropzone, {
        multiple: false,
        accept: "text/*",
        className: "button",
        style: dropStyle,
        onDrop: this.onDrop
      }, function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps;
        return React.createElement("button", getRootProps(), _this2.state.message, React.createElement("input", getInputProps()));
      });
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogUploader;
}(Component);
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogUploader, "LogUploader", "/srv/http/owncloud/apps/logreader/js/Components/LogUploader.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();